"use strict";

require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Button = _ref => {
  let {
    id,
    children,
    type = "cta",
    disabled = false,
    size = 'medium',
    isFullWidth = false,
    onClick,
    className,
    submit = false,
    textured = false,
    style,
    onMouseEnter,
    onMouseLeave
  } = _ref;
  const getBackgroundColor = () => {
    if (type === 'cta') return 'bg-blue';
    if (type === 'default') return 'bg-btn-default';
    return 'bg-btn-default';
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    id: id,
    className: "hpd-btn flex justify-content-center gap-05em border-none hoverable align-items-center white-space-no-wrap font-size-14px font-weight-400 font-family ".concat(getBackgroundColor(), " ").concat(isFullWidth ? 'full-width' : '', " bg-blue-hover color-white br-4px ").concat(size, " ").concat(className, " ").concat(disabled ? 'btn-disabled' : '').concat(textured ? ' textured' : ''),
    type: submit ? 'submit' : 'button',
    disabled: disabled,
    onClick: onClick,
    style: _objectSpread({
      lineHeight: '12px',
      padding: '10px 18px'
    }, style),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
};
var _default = exports.default = Button;